import React, { useEffect, useState } from "react";
import CompanyLinksApi from "../../services/companyLinks";
import AddCompanyLinkModal from "../CompanyLinks/AddCompanyLinkModal";
import ConfirmDeletePopup from "../../fragments/popup/ConfirmDeletePopup";
import './styles.css';
import { PopupboxContainer } from 'react-popupbox';

const CompanyLinks = (props) => {
  const [list, setList] = useState([])
  const [showModal, setShowModal] = useState(false);
  const [newLink, setNewLink] = useState({ name: "", url: "" });
  const [isAdding, setIsAdding] = useState(false);
  const companyLinksApi = new CompanyLinksApi(props.token);

  const fetchCompanyLinks = async () => {
    try {
      let response = await companyLinksApi.all()
      setList(response.companyLinks)
    } catch (error) {
      console.log('error', error)
      setList([])
    }
  }

  useEffect(() => {
    fetchCompanyLinks()
  }, [])

  const handleAddLink = async () => {
    if (!newLink.name || !newLink.url || isAdding) return; 
    try {
      setIsAdding(true);
      let formData = new FormData();
      formData.append("name", newLink.name);
      formData.append("url", newLink.url);
      await companyLinksApi.create(formData);
      await fetchCompanyLinks();
      setShowModal(false);
      setNewLink({ name: "", url: "" });
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsAdding(false);
    }
  };

  const handleDelete = async(id)=>{
    if (!id) return;
    try {
      await companyLinksApi.delete(id);
      await fetchCompanyLinks()
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleOnchange = (name, value)=>{
    setNewLink({ ...newLink, [name]: value })
  }

  return (
    <div className="company-link-container">
      <div className="organizations-custom-popup">
        <PopupboxContainer />
      </div>
      <button className="btn btn-add" onClick={() => setShowModal(true)}>
        New company link
      </button>
      <div className="card mt-3">
        <div className="card-header fw-bold">Company Links</div>
        <ul className="list-group list-group-flush">
          {list.length > 0 ? (
            list.map((link, index) => (
              <li className="list-group-item d-flex justify-content-between align-items-center" key={index}>
                <a href={link.url} className="text-decoration-none" target="_blank" rel="noopener noreferrer">
                  {link.name}
                </a>
                <ConfirmDeletePopup
                  onConfirm={() => handleDelete(link.id)}
                  prompt={`Are you sure to delete ${link.name} ?`}
                  acceptLabel="Delete"
                />
              </li>
            ))
          ) : (
            <div className="text-muted text-center p-2">No links available.</div>
          )}
        </ul>
      </div>
      <AddCompanyLinkModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onSave={handleAddLink}
        newLink={newLink}
        handleOnchange={handleOnchange}
        isAdding={isAdding}
      />
    </div>
  );
}

export default CompanyLinks